var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "58.5px",
    height: "43.5px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: "3px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fill: "none",
    d: "M4.500,4.500 L28.500,20.500 L52.500,4.500 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: "3px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fill: "none",
    d: "M3.500,37.500 L22.500,18.500 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: "3px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fill: "none",
    d: "M50.500,39.500 L31.500,20.500 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: "3px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fill: "none",
    d: "M6.500,1.500 L50.500,1.500 C53.261,1.500 55.500,3.739 55.500,6.500 L55.500,35.500 C55.500,38.261 53.261,40.500 50.500,40.500 L6.500,40.500 C3.739,40.500 1.500,38.261 1.500,35.500 L1.500,6.500 C1.500,3.739 3.739,1.500 6.500,1.500 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f3edc5e9ad9f60550b5b3d8228844584.svg";
export { ForwardRef as ReactComponent };